
<template>
  <div class="dialog" v-loading="loading">
    <div class="top">
      <div class="upload" style="text-align: center">
        <el-upload
            :http-request="handleUpload"
            class="upload-block"
            drag

            multiple>
          <el-button type="primary" style="margin: 40px 0 16px;">上传文件</el-button>
          <div class="el-upload__text">点击或将文件拖拽到这里上传</div>
          <div class="el-upload__text" style="color:#AEAEB2;margin-top: 10px;">支持格式：.xls .xlsx ，单个文件不能超过20MB</div>
        </el-upload>
      </div>
    </div>
    <div class="bottom">
      <div class="title">
        <span style="font-size: 16px">导入结果</span>
      </div>
      <div class="tab_button">
        <div class="tab_item" style="color: #07C160;" :class="{ 'active1': tableType === '1' }">
          <span>新增：{{formData.insert_count}}条</span>
          <span class="button"  @click="handleType('1')">点击查看</span>
        </div>
        <div class="tab_item" style="color: #E99D42;" :class="{ 'active2': tableType === '2' }">
          <span>更新：{{formData.update_count}}条</span>
          <span class="button"  @click="handleType('2')">点击查看</span>
        </div>
        <div class="tab_item" style="color: #BD3124;" :class="{ 'active3': tableType === '3' }">
          <span>失败：{{formData.fail_count}}条</span>
          <span class="button"   @click="handleType('3')">点击查看</span>
        </div>
      </div>
      <div>
        <el-table
          :data="tableData"
          :height="350"
          style="width: 100%;"
        >
          <el-table-column type="index" label="序号" width="60"></el-table-column>
          <el-table-column prop="di" label="DI码" width="180"></el-table-column>
          <el-table-column prop="reagent_name" label="产品名称" min-width="180"></el-table-column>
          <el-table-column prop="erp_id" label="对应ERP编码" width="120"></el-table-column>
          <el-table-column prop="standard" label="包装规格" width="120"></el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog
        title="提示"
        class="errorDialog"
        :visible.sync="dialogVisible"
        width="30%"
        :modal='false'
        :modal-append-to-body="false"
        :before-close="handleClose">
      <template v-slot:title>
        <span class="el-icon-warning" style="color: #FAAD15;margin-right: 10px;font-size:20px"></span>
        <span style="font-size: 16px">提示</span>
      </template>
      <span>Excel文件读取错误，请重新确认格式是否正确！</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {getExamDtl, getTrainOptions} from "@/api/training";
import axios from "axios";

export default {
  name: "addDialog",

  data() {
    return {
      token: localStorage.getItem('token') ||localStorage.getItem('vue_token'),
      uploadHeaders: {
        Authorization: `Bearer ${this.token}` // 假设你的后端需要这样的 Authorization 头部格式
      },
      loading: false,
      dialogVisible: false,
      tableType: '1',
      formData: {
        insert_count: 0,
        update_count: 0,
        fail_count: 0,
      },
      tableData: [],

    };
  },
  created() {

  },
  methods: {
    handleType(type){
      this.tableType = type
      if(type === '1'){
        this.tableData =this.formData.insert_list
      }else if(type === '2'){
        this.tableData =this.formData.update_list
      }else{
        this.tableData =this.formData.fail_list
      }
    },
    handleUpload(file){
      this.loading = true
      const formData = new FormData();
      formData.append('file', file.file);
      const config = {
        headers: {
          'Authorization': `Bearer ${this.token}`
        }
      };
      let baseUrl= process.env.VUE_APP_BASE_API
      axios.post(`${baseUrl}/api/reagents/di/import-excel/`, formData, config)
          .then(data => {
            if(data.data.code ==200){
              this.loading =false
              // 处理响应
              let resUrl =  data.data.data
              this.formData = resUrl
              this.tableData = this.formData.insert_list
              this.loading = false
            }else{
              this.loading = false
              // this.$message.error(data.data.msg)
              this.dialogVisible = true
            }
          })
          .catch(error => {
            // 处理错误
            this.loading = false
          });
    },
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-form-item{
  display: inline-block;
}
.half{
  width: 50%;
}
::v-deep .half .el-input{
  width: 88%;
  margin-right: 8px;
}
::v-deep .el-input .el-input__inner{
  width: 100%;
}
::v-deep .el-radio{
  display: block;
  vertical-align: middle;
  line-height: 40px;
}
.upload-demo{
  display: inline-block;
  width: 50%;
}
.video-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.video-uploader .el-upload:hover {
  border-color: #409eff;
}
.video-preview {
  margin-top: 10px;
}
.dialog{
  padding: 0 90px!important;
}

//
.tab_button{
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  .tab_item{
    display: inline-block;
    height: 50px;
    line-height: 50px;
    padding: 0px 15px;
    box-sizing: border-box;
    border:1px solid #EFEFEF;
    border-radius: 4px;
    span {
      display: inline-block;
    }
    span.button{
      height: 32px;
      line-height: 32px;
      cursor: pointer;
      border:1px solid #EFEFEF;
      padding: 0 10px;
      margin: 0 10px;
      border-radius: 4px;
    }
  }
}
.upload-block{
  display: inline-block;
  width: 360px;
  text-align: center;
}
::v-deep .upload-block .el-upload .el-upload-dragger{
  background: #F2F2F7;
  border:none;
}
::v-deep .el-upload-list{
  width: 360px;
  text-align: left;
}
.tab_button .tab_item.active1{
  border: 1px solid  #07C160;
}
.tab_button .tab_item.active2{
  border: 1px solid  #E99D42;
}
.tab_button .tab_item.active3{
  border: 1px solid  #BD3124;
}
.errorDialog {
  display: flex;
  padding: 20px;
  ::v-deep .el-dialog {
    margin: auto !important;
    box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.1);
  }

}

</style>